var _defs, _rect, _g, _g2, _g3, _circle, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent321V2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #83d4f7;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        opacity: .5;\n      }\n\n      .cls-4 {\n        stroke: #fff;\n        stroke-width: 5.09px;\n      }\n\n      .cls-4, .cls-5 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-8 {\n        fill: #bbf0f9;\n      }\n\n      .cls-9 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-5 {\n        stroke: #263238;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .cls-12 {\n        fill: #263238;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 95,
    cy: 55.4,
    fx: 95,
    fy: 55.4,
    r: 54.12,
    gradientTransform: "translate(15.55 150.9) rotate(-90.36) scale(1 1.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83d4f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#94daf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#c2eafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.81,
    dy: 0.81
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.61
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.36,
    dy: 2.36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5.89
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.68,
    y1: 75.97,
    x2: 60.65,
    y2: 75.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91d97b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94de7e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 0,
    width: 190,
    height: 110.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.04,47.28l-2.98,15.73-.16.83-2.24,11.82c-.53,2.8,1.31,5.5,4.11,6.02l54.71,10.36c2.8.53,5.49-1.31,6.02-4.11l5.38-28.39c.53-2.8-1.31-5.49-4.11-6.02l-54.71-10.36c-2.8-.53-5.49,1.31-6.02,4.1Zm6.94,16.02c-.27,1.42-1.64,2.35-3.05,2.08s-2.35-1.64-2.08-3.05c0-.02,0-.05.02-.07.06-.28.16-.54.3-.77.54-.93,1.63-1.46,2.74-1.25,1.42.27,2.35,1.64,2.08,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m105.72,59.51c2.19.96,3.84,1.75,4.43,2.04.1.05.17.08.21.1.17.08.26.27.22.44,0,.04-.02.07-.03.11-.1.2-.35.29-.55.19-.05-.02-.1-.05-.15-.07-1.11-.54-2.59-1.23-4.28-1.97-6.58-2.9-16.27-6.59-19.14-5.24-.38.18-.61.44-.7.81-.25,1.04,0,2.01.73,2.9,2.44,2.92,10.02,4.65,18.59,4.26l-.16.83c-8.85.37-16.44-1.43-19.06-4.57-.92-1.09-1.22-2.31-.9-3.62.15-.61.53-1.07,1.15-1.36,3.33-1.56,13.57,2.48,19.64,5.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m108.04,47.28l-2.98,15.73-.16.83-2.24,11.82c-.53,2.8,1.31,5.5,4.11,6.02l54.71,10.36c2.8.53,5.49-1.31,6.02-4.11l5.38-28.39c.53-2.8-1.31-5.49-4.11-6.02l-54.71-10.36c-2.8-.53-5.49,1.31-6.02,4.1Zm6.94,16.02c-.27,1.42-1.64,2.35-3.05,2.08s-2.35-1.64-2.08-3.05c0-.02,0-.05.02-.07.06-.28.16-.54.3-.77.54-.93,1.63-1.46,2.74-1.25,1.42.27,2.35,1.64,2.08,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m119.07,62.81l-1.6-.4.73-1.72,1.5.38c1.67-3.59,4.95-4.82,8.97-3.82,4.24,1.06,6.72,3.84,6.04,8.32l-4.94-1.23c.2-1.75-.64-2.9-2.06-3.26-1.21-.3-2.26.07-3.02,1.23l3.19.8-.74,1.72-3.2-.8-.07.28-.07.28,3.49.87-.74,1.72-2.9-.72c.12,1.37.88,2.19,2.09,2.49,1.42.35,2.7-.27,3.34-1.9l4.94,1.23c-1.51,4.26-5.01,5.57-9.24,4.51-4.02-1-6.34-3.63-6.12-7.58l-1.78-.44.73-1.72,1.32.33.07-.28.07-.28Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.03,19.7c-1.27-.94-2.72-1.66-4.38-2.05-5.95-1.39-12.04,1.23-16.07,3.65-2.99,1.79-6.52,2.5-9.97,1.99-4.64-.68-11.28-.77-16.24,2.81-8.47,6.1-5.05,20.31-3.14,25.93s6.49,12.58,8,16.91c1.18,3.36,7.08,21.21,13.03,28.72,1.7,2.15,3.41,3.45,5.01,3.32,7.19-.57,3.6-13.44,4.25-22.54.27-3.81.72-6.39,1.23-8.14.47-1.59,2.16-2.28,3.54-1.75h0c.41.16.8.43,1.11.82,1.15,1.42,2.56,3.63,4.27,7.05,3.63,7.24,5.33,18.53,10.47,19.38h0c.64.11,1.34.05,2.1-.2,6.86-2.24,4.61-31.94,4.35-36.51-.26-4.57,1.28-12.76.9-18.69-.32-4.95-1.99-15.86-8.47-20.69,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m71.64,69.65c-3.52,5.19,1.09,27.24-2.9,28.92-3.6,1.51-5.47-.92-5.47-.92h0c1.7,2.15,3.41,3.45,5.01,3.33,7.19-.57,3.6-13.44,4.25-22.54.27-3.81.72-6.39,1.23-8.14.47-1.59,2.16-2.28,3.54-1.75-.06-.04-3.37-2.27-5.66,1.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m76.43,21.72c-1.97.42-4.41,1.12-6.93,2.32-1.57.74-3.29,1.08-5.02.98-1.79-.1-4.29-.11-6.94.31-.73.11-.69,1.18.05,1.24,2.04.15,4.53.44,6.87,1.03,2.1.53,4.32.09,6.04-1.23,1.43-1.1,3.48-2.43,6.25-3.68.56-.25.28-1.09-.32-.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m95.8,38.58c-2.27,12.53-19.75,9.73-20.55,12.2-.81,2.47,12.49-.11,16.45,3.44,3.96,3.55,9.73,37.59,1.46,41.56.64.11,1.34.05,2.1-.2,6.86-2.24,4.61-31.94,4.35-36.51-.26-4.57,1.28-12.76.9-18.69-.32-4.95-1.99-15.86-8.47-20.69.07.13,5.04,11.86,3.77,18.88Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 47.67,
    cy: 75.97,
    r: 12.99
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "41.41 75.2 46.58 80.04 53.92 71.89"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 112.41,
    cy: 62.81,
    r: 2.61
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m139.25,64.55l-2.65-.64.62-2.54,1.88.46c.5.12.84-.08.97-.59l.13-.53,3.36.81-2.93,12.08-3.36-.81,2-8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m144.11,68.06c1-4.12,4.04-5.66,7.08-4.92,3.03.74,5.04,3.49,4.04,7.62s-4.04,5.66-7.08,4.92c-3.04-.74-5.04-3.49-4.04-7.62Zm4.69,4.94c1.18.29,2.42-.63,3.01-3.07.59-2.44-.09-3.82-1.27-4.11s-2.42.63-3.01,3.07c-.59,2.44.09,3.82,1.27,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m156.34,71.03c1-4.12,4.04-5.66,7.08-4.92,3.03.74,5.04,3.49,4.04,7.62s-4.04,5.66-7.08,4.92c-3.04-.74-5.04-3.49-4.04-7.62Zm4.69,4.94c1.18.29,2.42-.63,3.01-3.07.59-2.44-.09-3.82-1.27-4.11s-2.42.63-3.01,3.07c-.59,2.44.09,3.82,1.27,4.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent321V2);
export default __webpack_public_path__ + "static/media/event3-2.1_v2.329754d60e5a584ac1ee7778fb7fc5ce.svg";
export { ForwardRef as ReactComponent };